<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item label="中心仓库" prop="storehouseGuid">
            <customer-storehouse-select
              v-model="editModel.storehouseGuid"
              :disabled="!!editModel.guid"
            />
          </el-form-item>
          <el-form-item label="计划名称" prop="arrangedName">
            <el-input
              type="textarea"
              v-model="editModel.arrangedName"
              :rows="2"
              maxlength="256"
              placeholder="输入计划名称"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="editSubmit"
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";
import customerStoreSupplierSelect from "../../../../components/business/customerStoreSupplierSelect.vue";
import warehouseReplenishSelect from "../../../../components/business/warehouseReplenishSelect.vue";

const defaultModel = {
  storehouseGuid: "",
  arrangedName: "",
};

export default {
  components: {
    customerStorehouseSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    goodsSelectParams() {
      return {
        optSplit: 0,
      };
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        arrangedStoreGuid: [
          {
            required: true,
            message: "补货门店不能为空",
            trigger: "change",
          },
        ],
        arrangedName: [
          {
            required: true,
            message: "补货计划名称不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          let method = this.editModel.guid
            ? "biz.warehouse.arranged.info.update"
            : "biz.warehouse.arranged.info.create";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storehouseGuid) {
        this.editModel.storehouseGuid = this.pageParams.storehouseGuid;
      }
    },
    fetchModel() {
      // 新增
      let guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.loading = true;
        this.errorMsg = null;
        this.editModel = null;
        return this.requestApi("biz.warehouse.arranged.info.detail", {
          guid: this.pageParams.guid,
          storehouseGuid: this.pageParams.storehouseGuid,
        })
          .then((resp) => {
            this.editModel = Object.assign({}, defaultModel, resp.data);
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
